var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.3607,
    height: 42.3607,
    transform: "translate(0.819824)",
    fill: "#FF9515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 13.3529C33.1166 13.7647 32.1644 14.0353 31.1778 14.1647C32.1874 13.5412 32.9675 12.5529 33.3346 11.3647C32.3824 11.9529 31.327 12.3647 30.2141 12.6C29.3078 11.5882 28.0344 11 26.5889 11C23.8929 11 21.6902 13.2588 21.6902 16.0471C21.6902 16.4471 21.7361 16.8353 21.8164 17.2C17.7323 16.9882 14.0956 14.9765 11.675 11.9294C11.2505 12.6706 11.0096 13.5412 11.0096 14.4588C11.0096 16.2118 11.87 17.7647 13.2008 18.6471C12.3862 18.6471 11.6291 18.4118 10.9637 18.0588V18.0941C10.9637 20.5412 12.6616 22.5882 14.9101 23.0471C14.1882 23.2497 13.4303 23.2778 12.696 23.1294C13.0076 24.1323 13.6178 25.0099 14.4409 25.6387C15.264 26.2676 16.2586 26.6161 17.2849 26.6353C15.5453 28.0476 13.3889 28.811 11.1702 28.8C10.7801 28.8 10.3901 28.7765 10 28.7294C12.1797 30.1647 14.7725 31 17.5488 31C26.5889 31 31.5564 23.3059 31.5564 16.6353C31.5564 16.4118 31.5564 16.2 31.5449 15.9765C32.5086 15.2706 33.3346 14.3765 34 13.3529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiTwitter);
export default __webpack_public_path__ + "static/media/mdi_twitter.77c3966f3d315792618c79eae9626945.svg";
export { ForwardRef as ReactComponent };